import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { BaseCalculateResizableChildComponent } from '@common-modules/shared/core/responsive/base-calculate-resizable-child.component';
import { IElementSize } from '@common-modules/shared/model/element-size';
import { popupWrapperExtraHeight } from '@common-modules/shared/wrappers/popup-wrapper/popup-wrapper.component';
import { ChartType } from '@common-modules/wlm-charts/core/models/chart-type.enum';
import { TrendChartSettings } from '@common-modules/wlm-charts/core/models/trend-chart-settings';
import { Observable, of } from 'rxjs';
import { CategoryDto } from '../models/category.dto';

const COMPONENT_SELECTOR = 'tc-attributes-chart-popup.component';
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './attributes-chart-popup.component.html',
    styleUrls: ['./attributes-chart-popup.component.scss'],
    standalone: false
})
export class AttributesChartPopup extends BaseCalculateResizableChildComponent implements OnInit {
  dimensionToCalculate: 'height' | 'width' = 'height';
  readonly T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;
  attributesChartConfiguration: AttributesChartConfiguration;
  chartSettings: TrendChartSettings;
  load = false;
  private readonly _extraMarginsHeight = popupWrapperExtraHeight;

  constructor(
    private dialogRef: MatDialogRef<AttributesChartPopup>,
    @Inject(MAT_DIALOG_DATA) parameters: AttributesChartConfiguration
  ) {
    super();
    this.attributesChartConfiguration = parameters;
  }

  ngOnInit(): void {
    this.popuplateCharts();
    this.listenSelfContainerSize();
  }

  popuplateCharts(): void {
    this.chartSettings = {
      dataParameters: {
        dataService: 'AttributesChartService',
        startDate: this.attributesChartConfiguration.startDate,
        endDate: this.attributesChartConfiguration.endDate,
        queryParams: this.attributesChartConfiguration,
      },
      chartType: ChartType.trend,
    };
  }

  cancel() {
    this.dialogRef.close(false);
  }

  fixedSizes$(): Observable<IElementSize>[] {
    return [
      of({
        height: this._extraMarginsHeight,
        width: null,
      }),
    ];
  }
}

export class AttributesChartConfiguration {
  startDate: Date;
  endDate: Date;
  attributeNames: string[];
  scenarioId: string;
  snapshotId: string;
  networkElementId: string;
  category: CategoryDto;

  constructor(init: Partial<AttributesChartConfiguration>) {
    Object.assign(this, init);
  }
}
